import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {DateRangeShortLink, ShortLinkConfig} from '@components/form-field/form-date-range/date-range-short-link';
import {DateService} from '@services/date.service';
import {fullDateValidation, startEndDateValidation} from '@helpers/validators/frontendRequired';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {FormHelperService} from '@services/form-helper.service';

@Component({
    selector: 'app-form-date-range',
    templateUrl: './form-date-range.component.html',
    styleUrls: ['./form-date-range.component.scss']
})
export class FormDateRangeComponent implements OnInit, OnDestroy {

    @Input() fbControlDateFrom = new FormControl('');
    @Input() fbControlDateTo = new FormControl('');
    @Input() shortLinksConfig: ShortLinkConfig[];

    public shortLinks: DateRangeShortLink[] = [];

    ngOnInit() {
        this.fbControlDateFrom.setValidators([
            fullDateValidation(),
            startEndDateValidation(this.fbControlDateTo)
        ]);
        this.fbControlDateTo.setValidators([
            fullDateValidation()
        ]);

        if (this.shortLinksConfig && this.shortLinksConfig.length) {
            this.shortLinksConfig.forEach(config => this.shortLinks.push(new DateRangeShortLink(config)));
        }

        /**
         * При изменении даты окончания нужно провалидировать дату начала
         */
        this.fbControlDateTo.valueChanges.pipe(
            untilDestroyed(this)
        ).subscribe(() => this.fbControlDateFrom.updateValueAndValidity());
    }

    ngOnDestroy() {

    }

    onShortLinkClick(link: DateRangeShortLink) {
        FormHelperService.updateWithTouch(this.fbControlDateFrom, DateService.dateToFormat(link.dateFrom));
        FormHelperService.updateWithTouch(this.fbControlDateTo, DateService.dateToFormat(link.dateTo));
    }
}
